import { Box } from '@mui/material';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

export default function Badge() {
  return (
    <Box
      sx={{
        width: 72,
        height: 72,
        borderRadius: '22px',
        backgroundColor: '#FFD6CE',
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow:
          '0 20px 40px -18px rgba(255, 48, 8, 0.35), 0 0 0 6px rgba(255, 214, 206, 0.4)',
      }}>
      <ReceiptLongRoundedIcon sx={{ fontSize: 34 }} />
    </Box>
  );
}
